import React from 'react';

const IgnacioValentine = props => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 135 125"
    style={{
      enableBackground: 'new 0 0 135 125'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}'}</style>
    <g transform="matrix(-1 0 0 1 135 0)">
      <path
        className="st0"
        d="M39.5 1.6c17.3 0 31.3 14 31.3 31.3s-14 31.3-31.3 31.3-31.3-14-31.3-31.3 14-31.3 31.3-31.3m32.5 73 28.6-14.3-3.6-4.5H70.2"
      />
      <defs>
        <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse">
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000144305446489194037530000006238832761938385841_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter)'
          }}
        >
          <path
            id="a_00000059308398948233354090000001076626429437550994_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M8.2 100.9h62.6V35H8.2v65.9z"
        style={{
          mask: 'url(#b_00000144305446489194037530000006238832761938385841_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#fff'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000103266440388219239650000016013844124107040906_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000021813164657029700020000018298966498740243863_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000103266440388219239650000016013844124107040906_)'
          }}
        >
          <path
            id="a_00000076569306344775124350000011828878886652142259_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="m71.3 117.3-4.5 7.2-17.9-23.2-20.6 2.7-5.3 17.7H6l1.8-6.3V87.8l-5.4-3.6 6.3-28.6h62.6v61.7z"
        style={{
          mask: 'url(#b_00000021813164657029700020000018298966498740243863_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#fff'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000019659017096964025610000011165364985935984260_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000005235939867094255510000013081851923386771646_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000019659017096964025610000011165364985935984260_)'
          }}
        >
          <path
            id="a_00000040569473581407243170000016607813246192752049_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="m48.6 101.2-19.7 2.2s-2.3 7.7-3.9 13.3c-1 3.4-4.1 5.7-7.7 5.7H9s1.2-1.6 2.2-2.9c.9-1.2 1.4-2.7 1.4-4.3 0-6.9-.1-26.3-.1-26.3l-4.6-1.5s-.4-.4-1-.9c-1.4-1.4-2-3.4-1.5-5.3 1.8-6.6 5.9-21.3 5.9-21.3H40c.7 0 1.2.5 1.2 1.2 0 3.8 3.1 6.9 6.9 6.9h1.3c3.9 0 7-3.1 7.1-7 0-.6.5-1 1-1h35.8c2.2 0 3.9-1.7 3.9-3.9 0-.2 0-.4-.1-.6l3.1 5.5-2.7 3.9-9.7.6-17.3 7.9v43.2s.6.7 1.4 1.6c.7.8.8 1.9.4 2.9s-1.4 1.6-2.4 1.6h-16l-5.3-21.5z"
        style={{
          mask: 'url(#b_00000005235939867094255510000013081851923386771646_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#b8ebff'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000073700558583101420030000013084505183797346443_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000128446468452168633040000011735937777844576953_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000073700558583101420030000013084505183797346443_)'
          }}
        >
          <path
            id="a_00000024001739143137625760000005629739228857224088_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M20.6 124.3H8.4c-1.7 0-3.2-1-3.9-2.6-.7-1.6-.4-3.4.7-4.6.7-.8 1.2-1.9 1.2-3V88.5c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v25.6c0 2-.7 3.9-2 5.3l-.1.1c-.2.2-.2.5-.1.8.1.3.4.4.7.4h12.2c.8 0 1.5-.5 1.7-1.3l4.8-16.4 3.4 1-4.8 16.4c-.7 2.3-2.8 3.9-5.2 3.9m49.7 0h-13c-2.4 0-4.5-1.6-5.2-4-1.5-5.7-5.1-18.8-5.1-18.8l3.5-.9s3.5 13.1 5.1 18.8c.2.8.9 1.3 1.7 1.3h13c.3.3.7.3 1 .1.3-.3.3-.7.1-1-.1-.2-.3-.3-.6-.3-1.3-1.5-2-3.4-2-5.3v-39c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v39c0 1.1.4 2.2 1.1 3 0 0 0 .1.1.1 1.1 1.3 1.3 3 .6 4.6-.7 1.4-2.2 2.4-3.9 2.4"
        style={{
          mask: 'url(#b_00000128446468452168633040000011735937777844576953_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000153689294762581082780000007039014036931226020_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000074428178402009438940000002216335239169405084_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000153689294762581082780000007039014036931226020_)'
          }}
        >
          <path
            id="a_00000005240737886027576730000011461167498115802242_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M21.5 106.2c-1 0-1.8-.8-1.8-1.8 0-.9.7-1.7 1.6-1.8l34-4.3c1-.1 1.9.6 2 1.6.1.9-.6 1.8-1.5 1.9l-34 4.3c-.1.1-.2.1-.3.1m27.4-40.9c-2.7 0-4.9-2.2-4.9-4.9V60c0-1.5-1.2-2.7-2.7-2.7H8.1c-1 0-1.8-.9-1.7-1.8 0-.9.8-1.7 1.7-1.7h33.2c3.5 0 6.3 2.8 6.3 6.3v.4c0 .7.6 1.3 1.3 1.3.4 0 .7-.1 1-.4.3-.2.4-.6.4-.9v-.4c0-3.5 2.8-6.3 6.3-6.3h14.2c1 0 1.8.8 1.8 1.8s-.8 1.8-1.8 1.8H56.5c-1.5 0-2.7 1.2-2.7 2.7v.5c0 1.3-.5 2.6-1.4 3.5-1 .7-2.2 1.2-3.5 1.2"
        style={{
          mask: 'url(#b_00000074428178402009438940000002216335239169405084_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000163791647433017991560000001721024782259761061_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000036236795247164277600000016426716915097817770_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000163791647433017991560000001721024782259761061_)'
          }}
        >
          <path
            id="a_00000089553075639570339610000009436127656964633729_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M8.1 57.2c-1 0-1.8-.8-1.8-1.8V33.1c0-6.9 2.1-13.4 6-19 .6-.8 1.7-1 2.5-.4s1 1.7.4 2.5c-3.5 5-5.4 10.8-5.4 16.9v22.3c.1 1-.7 1.8-1.7 1.8m12.7-26c-1.7 3.8-.6 8.4 2.9 10.9s8.2 2.2 11.3-.6L20.8 31.2zm8.1 16.2c-2.6 0-5.1-.8-7.4-2.4-5.6-4.1-6.8-11.9-2.7-17.5.6-.8 1.7-1 2.5-.4l17.3 12.6c.8.6 1 1.7.4 2.5-2.4 3.4-6.2 5.2-10.1 5.2z"
        style={{
          mask: 'url(#b_00000036236795247164277600000016426716915097817770_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000026157983976739973750000005306876225783017137_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000124860183966373018850000006849691158761819816_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000026157983976739973750000005306876225783017137_)'
          }}
        >
          <path
            id="a_00000006695493613156285030000017309497372548228487_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M13.8 16.9c-.4 0-.7-.1-1.1-.4l-8.4-6.2c-.7-.5-.9-1.6-.3-2.4s1.7-1 2.5-.4l8.4 6.2c.8.6 1 1.7.4 2.5-.4.4-.9.7-1.5.7m4.1-5.3c-.4 0-.8-.1-1.1-.4L11 6.6c-.8-.6-.9-1.7-.3-2.5.6-.8 1.7-.9 2.5-.3L19 8.4c.8.6.9 1.7.3 2.5-.3.5-.8.7-1.4.7M23.3 8c-.4 0-.8-.1-1.1-.4l-4.5-3.4c-.8-.6-.9-1.8-.2-2.5.6-.7 1.7-.9 2.4-.3l4.5 3.4c.8.6.9 1.7.3 2.5-.3.5-.8.7-1.4.7"
        style={{
          mask: 'url(#b_00000124860183966373018850000006849691158761819816_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000163033750918275092450000011266000165129401266_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000148641663858098432950000014794352702405471362_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000163033750918275092450000011266000165129401266_)'
          }}
        >
          <path
            id="a_00000060715437522094042150000002392295820620526757_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M70.7 57.2c-1 0-1.8-.8-1.8-1.8V33.1c0-16.3-13.2-29.5-29.5-29.5C34 3.6 28.8 5 24.2 7.8c-.9.5-2 .2-2.4-.7-.5-.8-.2-1.9.6-2.4 5.1-3.1 11-4.7 17-4.7 18.2 0 33.1 14.8 33.1 33.1v22.3c0 1-.8 1.8-1.8 1.8"
        style={{
          mask: 'url(#b_00000148641663858098432950000014794352702405471362_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000036251658804828553540000003057888887555826363_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000132803007397780665600000008035446981863600568_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000036251658804828553540000003057888887555826363_)'
          }}
        >
          <path
            id="a_00000038412657913830574520000010275969763820307135_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M46.6 35.1c-1.1 0-2-.9-2-2V22.4c0-1.1.9-2 2.1-2 1.1 0 1.9.9 2 2v10.7c-.1 1.1-1 2-2.1 2m10.7 0c-1.1 0-2-.9-2-2V22.4c0-1.1.9-2 2.1-2 1.1 0 1.9.9 2 2v10.7c-.1 1.1-1 2-2.1 2m13.4 41.8c-1 0-1.8-.8-1.8-1.8 0-.6.3-1.2.9-1.6l17.4-9.8c.3-.2.6-.2.9-.2h7.2c1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.2-3.1h-26c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8h26a6.7 6.7 0 0 1 0 13.4h-6.8l-17 9.6c-.1.1-.4.2-.7.2"
        style={{
          mask: 'url(#b_00000132803007397780665600000008035446981863600568_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000102513627391641626070000017570938227134151328_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000067219639468900202560000015406945446565874589_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000102513627391641626070000017570938227134151328_)'
          }}
        >
          <path
            id="a_00000168807131558712273260000013303857677196431523_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M28.7 79.1c-1.4-2-2.8-4-4.1-6-.3-.4-.5-.9-.5-1.5-.2-1.3.3-2.6 1.3-3.4.8-.7 1.9-.9 3-.7.4.1.7.2 1.1.4.5.3.9.7 1.2 1.1l.8 1.2c.3-.4.5-.8.8-1.2.1-.1.1-.2.2-.3l.6-.6c.4-.3 1-.6 1.5-.7.2 0 .4-.1.6-.1.6 0 1.2.1 1.7.4l.9.6c.8.8 1.3 2 1.1 3.1-.1.5-.2.9-.5 1.4-1.1 1.7-2.1 3.4-3.2 5.1"
        style={{
          mask: 'url(#b_00000067219639468900202560000015406945446565874589_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#fff'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000159471846679077942790000002386838612811764394_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000105389234167429206970000005220633092534783364_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000159471846679077942790000002386838612811764394_)'
          }}
        >
          <path
            id="a_00000004505692193555703820000004449780849557554612_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M28.7 80.9c-.6 0-1.1-.3-1.5-.8-1.4-2-2.8-4-4.1-6-.5-.7-.7-1.5-.8-2.2-.2-1.4.1-2.7.9-3.9.3-.4.7-.8 1.1-1.1 1.7-1.4 4.1-1.6 6-.5.4.2.8.5 1.2.9l.5-.5c.7-.5 1.4-.9 2.2-1 .3-.1.6-.1.9-.1h.3c.8 0 1.6.2 2.3.6.5.2.9.5 1.3.9 1.3 1.2 1.9 2.9 1.7 4.7-.1.7-.3 1.4-.7 2-1.1 1.7-2.2 3.4-3.3 5.2-.5.8-1.6 1.1-2.5.5-.8-.5-1.1-1.6-.5-2.5 1.1-1.7 2.1-3.3 3.2-5 .1-.2.2-.4.2-.7.1-.6-.1-1.2-.6-1.6-.1-.1-.3-.2-.4-.3-.2-.1-.5-.2-.8-.2h-.1c-.4 0-.8.2-1.1.4l-.3.3-.1.2-.4.6-.3.6c-.3.5-.9.8-1.5.8s-1.2-.3-1.5-.8l-.9-1.2-.6-.6c-.7-.4-1.5-.3-2.1.2-.1.1-.3.2-.4.4-.3.4-.4.8-.3 1.3 0 .3.1.5.3.8 1.3 2 2.7 3.9 4 5.9.6.8.4 1.9-.4 2.5-.2.1-.5.2-.9.2"
        style={{
          mask: 'url(#b_00000105389234167429206970000005220633092534783364_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000168096186835421370390000001778949259327993757_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000106859426167179817570000014017670976764929460_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000168096186835421370390000001778949259327993757_)'
          }}
        >
          <path
            id="a_00000000216737080679522490000010732469961728990636_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M13.7 77.1v-5.8c0-.5.2-1.1.4-1.5.2-.4.5-.8.8-1.1.3-.3.7-.6 1.2-.7.3-.1.7-.2 1-.2 1.1-.1 2.1.3 2.9 1.1.3.3.5.6.7.9.2.5.4 1.1.4 1.6v1.5c.5-.2.9-.4 1.4-.6.4-.1.8-.2 1.1-.2.8 0 1.6.2 2.2.6.1.1.1.1.2.1.4.3.8.7 1 1.2.2.3.3.6.4 1 .3 1.2-.1 2.4-.9 3.3-.3.4-.7.7-1.2.9"
        style={{
          mask: 'url(#b_00000106859426167179817570000014017670976764929460_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#fff'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000150097492981869706430000002179910205990818211_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000103980459989199304940000009270954932652670352_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000150097492981869706430000002179910205990818211_)'
          }}
        >
          <path
            id="a_00000119083595562130089150000011271812337302634900_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M25.4 81a1.793 1.793 0 0 1-.8-3.4c.3-.1.5-.3.6-.5.4-.5.6-1.1.5-1.7 0-.2-.1-.4-.2-.5-.1-.2-.3-.5-.6-.6l-.1-.1c-.1-.1-.2-.1-.3-.1-.3-.1-.6-.2-.9-.2-.2 0-.4.1-.6.1-.3.1-.6.3-1 .4l-.3.1c-.9.4-2 0-2.3-.9-.1-.2-.1-.5-.1-.7v-1.5c0-.3-.1-.6-.2-.9-.4-.9-1.5-1.3-2.4-.9-.2.1-.4.2-.6.4-.2.2-.3.3-.4.6-.1.2-.2.5-.2.8v5.7c0 1-.8 1.8-1.8 1.8s-1.8-.8-1.8-1.8v-5.8c0-.9.2-1.6.6-2.3.3-.6.7-1.2 1.2-1.6.5-.5 1.1-.8 1.8-1.1 2.6-1 5.6.2 6.9 2.7.2.5.4 1 .5 1.5.2 0 .5-.1.7-.1.8 0 1.7.1 2.5.4.3.1.5.3.8.4l.2.2c.7.5 1.2 1.1 1.6 1.8.3.5.4 1 .6 1.5.4 1.7-.1 3.5-1.3 4.8-.5.5-1.1 1-1.7 1.3-.3.1-.6.2-.9.2"
        style={{
          mask: 'url(#b_00000103980459989199304940000009270954932652670352_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000043423510764138095800000017544438356569998005_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000057148779667901104440000010268733491514870705_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000043423510764138095800000017544438356569998005_)'
          }}
        >
          <path
            id="a_00000147905699245220872700000009532720590111890877_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M10.7 90.3c-3.3 0-6.5-1.6-8.5-4.2-2-2.7-2.7-6.1-1.8-9.3C3 67.2 6.4 55 6.4 55l3.4 1s-3.4 12.2-6 21.7c-.6 2.1-.1 4.4 1.2 6.2 1.3 1.8 3.4 2.8 5.7 2.8H35c.6 0 1.2-.2 1.7-.5.7-.5 1.2-1.2 1.3-2 .3-1.7-.7-3.3-2.4-3.7-1.1-.2-2.2.1-2.9 1-.4.4-1 .6-1.6.5l-18.7-3.4c-1-.2-1.6-1.1-1.4-2.1.2-1 1.1-1.6 2.1-1.4L31 78.3c.2-.1.3-.2.5-.3 3.1-2 7.3-1.2 9.3 1.9 1 1.5 1.3 3.3 1 5-.4 1.7-1.4 3.3-2.9 4.3-1.1.7-2.4 1.1-3.6 1.1H10.7z"
        style={{
          mask: 'url(#b_00000057148779667901104440000010268733491514870705_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#00aef0'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000064330436598270694630000013769614878150428068_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000021119182232977340210000005243917741666761634_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000064330436598270694630000013769614878150428068_)'
          }}
        >
          <path
            id="a_00000106853692822064383700000006827877017776106924_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M130.2 32.6c.6.4 1.1.9 1.5 1.5.3.4.5.8.6 1.3.4 1.5.1 3.1-.8 4.4-.4.5-.9.9-1.5 1.3-2.8 1.5-5.6 2.9-8.4 4.3-.6.3-1.2.4-1.9.5-.5 0-.9 0-1.4-.1-1.3-.3-2.4-1.2-3-2.3-.3-.6-.5-1.2-.6-1.9-.3-3.2-.5-6.4-.8-9.6 0-.7.1-1.4.3-2.1.2-.6.6-1.1 1-1.5.4-.4.9-.8 1.5-1.1.4-.2.9-.3 1.3-.4 1.4-.2 2.8.2 3.9 1.1.4.3.7.7 1 1.2.4.6.6 1.4.7 2.1l.2 2c.6-.3 1.2-.6 1.7-.9.1-.1.2-.1.4-.2 1.3-.5 2.8-.4 4.1.3l.2.1"
        style={{
          mask: 'url(#b_00000021119182232977340210000005243917741666761634_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#fff'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000098201556719830585600000004567259610971835813_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000011731660628557411900000002539658156863457462_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000098201556719830585600000004567259610971835813_)'
          }}
        >
          <path
            id="a_00000169543182837826660120000017861930149591097991_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M118.7 28.5c-.8 0-1.6.3-2.2.9-.3.3-.5.6-.6 1-.2.4-.2.8-.2 1.3.2 3.1.5 6.3.7 9.5 0 .4.2.8.4 1.2.4.7 1.1 1.3 1.9 1.5.3.1.6.1.9.1.4 0 .8-.1 1.2-.3 2.8-1.4 5.5-2.8 8.3-4.3.3-.2.7-.5.9-.8.6-.8.8-1.8.5-2.8-.1-.3-.2-.5-.4-.8-.2-.4-.6-.7-.9-.9l-.2-.1c-.9-.5-1.9-.5-2.8 0-.4.2-.7.4-1.1.6l-.6.3c-.9.5-2 .1-2.4-.8-.1-.2-.2-.4-.2-.7l-.2-2c0-.5-.2-.9-.4-1.3-.2-.3-.4-.5-.6-.7-.5-.6-1.2-.9-2-.9m.8 19.1c-.5 0-1.1-.1-1.6-.2-1.8-.4-3.3-1.6-4.2-3.2-.4-.8-.7-1.7-.8-2.6-.3-3.2-.6-6.5-.8-9.7 0-1 .1-2 .5-2.8.3-.8.8-1.5 1.4-2.1.6-.6 1.3-1.1 2-1.4.6-.3 1.2-.5 1.8-.5 1.9-.3 3.9.3 5.3 1.6.5.5 1 1 1.3 1.6.4.7.7 1.5.8 2.3.5-.2.9-.3 1.4-.4 1.4-.2 2.8.1 4 .7l.3.2h.1c.8.5 1.5 1.2 2 2 .3.5.6 1.1.8 1.7.6 2.1.2 4.3-1.1 6-.5.7-1.2 1.3-2 1.7-2.8 1.5-5.6 3-8.5 4.4-.9.4-1.8.6-2.6.7h-.1"
        style={{
          mask: 'url(#b_00000011731660628557411900000002539658156863457462_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#f7988b'
        }}
      />
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter_00000071553977697030616730000018039725258160075917_"
          filterUnits="userSpaceOnUse"
        >
          <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
        </filter>
      </defs>
      <mask maskUnits="userSpaceOnUse" id="b_00000114790787468332272360000007375504444837327245_">
        <g
          style={{
            filter: 'url(#Adobe_OpacityMaskFilter_00000071553977697030616730000018039725258160075917_)'
          }}
        >
          <path
            id="a_00000063607427446347572140000009040522658784537248_"
            className="st0"
            d="M0 124.4h134.2V0H0v124.4z"
          />
        </g>
      </mask>
      <path
        d="M99.3 50.6c-1 0-1.8-.8-1.8-1.8 0-.6.3-1.2.9-1.6l8.9-5.1c.9-.5 1.9-.2 2.4.7s.2 1.9-.7 2.4l-8.9 5.1c-.2.2-.5.3-.8.3m-11.7-2.3c-1 0-1.8-.8-1.8-1.8 0-.6.3-1.2.9-1.6L105.5 34c.8-.5 1.9-.3 2.5.6s.3 1.9-.6 2.5c0 0-.1 0-.1.1L88.5 48c-.3.2-.6.3-.9.3m18.6 7.1c-.6 0-1.2-.3-1.6-.9-.5-.9-.2-1.9.7-2.4l6.4-3.7c.9-.5 1.9-.2 2.4.7s.2 1.9-.7 2.4l-6.4 3.7c-.2.2-.5.2-.8.2"
        style={{
          mask: 'url(#b_00000114790787468332272360000007375504444837327245_)',
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#b8ebff'
        }}
      />
    </g>
  </svg>
);

export default IgnacioValentine;
